export class Temporarypasswordchange {
  id: number;
  userId: number;
  dateTypeId: number;
  timeOnNumber: number;
  createAt: string;
  dateStart: string;
  dateEnd: string;
  active: boolean;
  deleted: boolean;
}
